import React, { useRef, useState } from "react";
import { PieChartHeader } from "./PieChartHeader";
import { PieChartActions } from "./PieChartActions";
import { PieChartCanvas } from "./PieChartCanvas";
import { PieChartModal } from "./PieChartModal";
import { usePieChartExport } from "./hooks/usePieChartExport";
import type { PieChartData } from "@/lib/chat/parsePieChartBlock";

interface PieChartProps {
  data: PieChartData;
}

export const PieChart: React.FC<PieChartProps> = ({ data }) => {
  const exportRef = useRef<HTMLDivElement>(null);
  const [expanded, setExpanded] = useState(false);
  const { exportPNG } = usePieChartExport(exportRef, data.title);

  return (
    <>
      <div className="relative w-full overflow-hidden rounded-xl border border-border/60 bg-card shadow-sm">
        <div ref={exportRef}>
          <PieChartHeader title={data.title} />
          <PieChartCanvas data={data} />
        </div>
        <PieChartActions
          onDownload={exportPNG}
          onExpand={() => setExpanded(true)}
        />
      </div>

      <PieChartModal
        open={expanded}
        onClose={() => setExpanded(false)}
        data={data}
      />
    </>
  );
};
